import { useCallback, useState } from "react";
import { Text, Heading } from "@otrium/atoms";
import { Box } from "@otrium/core";
import { Trans, t } from "@lingui/macro";
import { ResetPasswordForm } from "src/molecules/ResetPasswordForm";
import { PageHead } from "src/molecules/PageHead";
import { useLingui } from "@lingui/react";
import styles from "./ResetPasswordView.module.scss";

function ResetPasswordView() {
  const [censoredEmail, setCensoredEmail] = useState<string>("");
  const [isEmailSubmitted, setIsEmailSubmitted] = useState<boolean>(false);
  const { i18n } = useLingui();

  const onSuccessfulSubmit = useCallback(
    (email: string) => {
      setIsEmailSubmitted(true);
      setCensoredEmail(email);
    },
    [setIsEmailSubmitted]
  );

  return (
    <>
      <PageHead title={t(i18n)`Reset password`} />
      <div className={styles.root}>
        {/* reset password form */}
        {
          <Box>
            <Heading
              as="h1"
              color={"tone.black"}
              fontSize={["32px", "32px", "32px", "48px"]}
              fontFamily="PlusJakartaSans"
              lineHeight={["40px", "40px", "40px", "58px"]}
              sx={{
                textTransform: "none",
              }}
            >
              <Trans>Reset password</Trans>
            </Heading>
          </Box>
        }
        {!isEmailSubmitted ? (
          <>
            <Box mt={4} py={2}>
              <Text fontSize="16px" lineHeight="24px">
                <Trans>Forgotten your password? No problem!</Trans>
              </Text>
              <Text fontSize="16px" lineHeight="24px">
                <Trans>We’ll send you an email to reset your password.</Trans>
              </Text>
            </Box>
            <ResetPasswordForm onSuccessfulSubmit={onSuccessfulSubmit} />
          </>
        ) : (
          <Box mt={4} py={2}>
            <Text
              data-testid="reset-password-form-success-message"
              fontSize="16px"
              lineHeight="24px"
            >
              <Trans>Success!</Trans>
            </Text>
            <Text fontSize="16px" lineHeight="24px">
              <Trans>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                We've sent an email to {censoredEmail} with password reset
                instructions.
              </Trans>
            </Text>
          </Box>
        )}
      </div>
    </>
  );
}

export default ResetPasswordView;
